export const useSidebarStore = defineStore("sidebarStore", () => {
    const sidebarOpen = ref<boolean>(false);

    return {
        sidebarOpen,
    };
});
